import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
} from "react-icons/fa";
import { motion } from "framer-motion";

const CTASection = () => {
  return (
    <section
      className="relative py-16 md:py-28 overflow-hidden"
      style={{
        backgroundImage:
          "linear-gradient(rgba(8,43,87,.92), rgba(8,43,87,.92)), url('/images/cta-bg.jpg')",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      {/* Decorative Elements */}

      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-5 pointer-events-none">
        <div className="absolute -top-20 -left-20 w-64 h-64 md:w-96 md:h-96 border border-white rounded-full opacity-50"></div>

        <div className="absolute bottom-0 right-0 w-[300px] h-[300px] md:w-[500px] md:h-[500px] border border-white rounded-full"></div>
      </div>

      <div className="container-custom relative z-10">

        <motion.div
          initial={{
            opacity: 0,
            y: 50,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.7,
          }}
          viewport={{ once: true }}
          className="max-w-5xl mx-auto text-center"
        >

          <span className="inline-block bg-[#F59E0B]/20 text-[#F59E0B] px-5 py-2 rounded-full font-medium">
            Let's Build Something Great Together
          </span>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-8 leading-tight">
            Ready To Build Your
            <span className="text-[#F59E0B] block">
              Dream Project?
            </span>
          </h2>

          <p className="text-white/80 text-lg leading-8 mt-8 max-w-3xl mx-auto">
            Whether you're planning a residential project,
            commercial development, property investment,
            or liaisoning services, our team is ready
            to help bring your vision to life.
          </p>

          {/* Contact Info */}

          <div className="flex flex-wrap justify-center gap-8 mt-10 text-white">

            <div className="flex items-center gap-3">
              <FaPhoneAlt className="text-[#F59E0B]" />
              <span>+91 99266 66609, +91 83195 69994</span>
            </div>

            <div className="flex items-center gap-3">
              <FaEnvelope className="text-[#F59E0B]" />
              <span className="break-all">contact@azconstruction.com</span>
            </div>

          </div>

          {/* Buttons */}

          <div className="flex flex-col sm:flex-row justify-center items-center gap-5 mt-12 max-w-md mx-auto sm:max-w-none">
            <a
              href="https://wa.me/919926666609"
              target="_blank"
              rel="noreferrer"
              className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl font-semibold flex items-center justify-center gap-3 transition"
            >
              <FaWhatsapp />
              WhatsApp Us
            </a>

            <Link
              to="/contact-us"
              className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-[#082B57] px-8 py-4 rounded-xl font-semibold flex items-center justify-center transition"
            >
              Get Free Consultation
            </Link>

          </div>

        </motion.div>

      </div>
    </section>
  );
};

export default CTASection;